export default "__VITE_ASSET__C3yxq2Hk__"